import { render, staticRenderFns } from "./DiscussionItem.vue?vue&type=template&id=7ce08f58"
import script from "./DiscussionItem.vue?vue&type=script&lang=js"
export * from "./DiscussionItem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports